/**
 * @file index.tsx
 *
 * @fileoverview Renders a Captcha component.
 */
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
interface CaptchaProps {
  /**
   * Callback function that is called when the captcha is changed.
   */
  onCaptchaChange: (value: string | null) => void;
  /**
   * reCAPTCHA site key from backend config. Falls back to env var.
   */
  siteKey?: string;
}
export default function Captcha({ onCaptchaChange, siteKey }: CaptchaProps) {
  const testing = process.env.testing;
  const staging = process.env.staging;
  const captchaSiteKey = siteKey || process.env.RECAPTCHA_SITE_KEY;

  const includeCaptcha = captchaSiteKey && !testing && !staging;

  if (!includeCaptcha) {
    onCaptchaChange('true');
  }

  return includeCaptcha ? (
    <ReCAPTCHA sitekey={captchaSiteKey} onChange={onCaptchaChange} />
  ) : null;
}
